'use client';

import { ProgressProvider } from '@bprogress/next/app';
import { ClerkProvider } from '@clerk/nextjs';
import { Provider as JotaiProvider } from 'jotai';
import { ThemeProvider } from 'next-themes';
import { NuqsAdapter } from 'nuqs/adapters/next/app';

import { Announcement, SuspendedPostHogPageView as PostHogPageView } from '@/components/analytics';
import { Toaster } from '@/components/ui/sonner';

type ProvidersProps = Readonly<{
  children: React.ReactNode;
}>;

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <ProgressProvider height="2px" color="#27AAE1" options={{ showSpinner: false }} shallowRouting>
        <ClerkProvider>
          <PostHogPageView />
          <Announcement />
          <NuqsAdapter>
            <JotaiProvider>{children}</JotaiProvider>
          </NuqsAdapter>
        </ClerkProvider>
      </ProgressProvider>
      <Toaster richColors />
    </ThemeProvider>
  );
};
